import { ActionTree } from 'vuex';

import { State } from '@/manager/sync/store/state';
import $http from '@/core/services/http.service';
import Endpoints from '@/constants/endpoints';

export interface Actions {
    fetchOperationList: {  };
}

export const actions: ActionTree<State, any> = {
    fetchOperationList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {};
            if ( payload.limit > -1 ) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params.search = payload.search;
            }
            if (payload.from) {
                params.date_from = payload.from;
            }
            if (payload.to) {
                params.date_to = payload.to;
            }
            if (payload.type) {
                params.type = payload.type;
            }
            if (payload.ordering) {
                params.ordering = payload.ordering;
            }
            $http.get(`${Endpoints.sync}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setOperationList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchOperationTypeList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {};
            if ( payload && payload.type ) {
                params.mode = payload.type;
            }
            $http.get(`${Endpoints.sync}type/`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setOperationTypeList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchKpiList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {};
            if (payload.from) {
                params.date_from = payload.from;
            }
            if (payload.to) {
                params.date_to = payload.to;
            }
            $http.get(`${Endpoints.sync}kpi/`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setKpiList', data);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    patchOperation: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.patch(`${Endpoints.sync}${payload.id}/`, payload.data)
                .then((res) => {
                    commit('updateOperation', res.data);
                    resolve(res.data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
};
